import { HttpClient } from '@angular/common/http';
import { Injectable, inject, provideEnvironmentInitializer } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@galaxy/core';
import { resolveRpcHost } from './host-resolution';

export interface RpcCallOptions {
  retryable?: boolean;
  timeoutMs?: number;
}

export interface RpcTransport {
  post(path: string, body: unknown, _options?: RpcCallOptions): Observable<Record<string, unknown>>;
}

let _transport: RpcTransport | null = null;

export function setGlobalTransport(transport: RpcTransport) {
  _transport = transport;
}

export function getGlobalTransport(): RpcTransport {
  if (!_transport) {
    throw new Error('Proto transport not initialized. Add provideProtoTransport() to your app config.');
  }
  return _transport;
}

export function provideProtoTransport() {
  return provideEnvironmentInitializer(() => setGlobalTransport(inject(HttpRpcTransport)));
}

@Injectable({ providedIn: 'root' })
export class RpcUrlResolver {
  private environmentService = inject(EnvironmentService);

  resolve(rpcPath: string): string {
    const host = resolveRpcHost(rpcPath, this.environmentService.getEnvironmentString());
    return `${host}/${rpcPath}`;
  }
}

@Injectable({ providedIn: 'root' })
export class HttpRpcTransport implements RpcTransport {
  private http = inject(HttpClient);
  private resolver = inject(RpcUrlResolver);

  post(path: string, body: unknown, _options?: RpcCallOptions): Observable<Record<string, unknown>> {
    const url = this.resolver.resolve(path);
    return this.http.post<Record<string, unknown>>(url, body, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
  }
}
